import { createGlobalStyle } from "styled-components";

// Material-UI 테마가 적용돼서 반영되지 않을 수도 있음.
const GlobalStyle = createGlobalStyle`
    body {
        
    }
`;

export default GlobalStyle;